import { FC } from "react";
import { FiArrowRight } from "react-icons/fi";
import { CiCircleRemove } from "react-icons/ci";
import { MdWallet } from "react-icons/md";
import { Input } from "../inputs/inputs";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";
import "./cashbackInput.css";

type Props = {
  redeemValue: string;
  setRedeemValue: (value: string) => void;
  availableBalance: number;
  hasCashback: boolean;
  appliedAmount: number;
  disabled?: boolean;
  loading?: boolean;
  backgroundColor?: string;
  onApply: () => Promise<void> | void;
  onRemove: () => Promise<void> | void;
};

const CashbackInput: FC<Props> = ({
  redeemValue,
  setRedeemValue,
  availableBalance,
  hasCashback,
  appliedAmount,
  disabled = false,
  loading = false,
  backgroundColor = "#f6f6fa",
  onApply,
  onRemove,
}) => {
  const handleChange = (value: string) => {
    const sanitized = value.replace(/[^\d.,]/g, "").replace(",", ".");

    const parts = sanitized.split(".");
    if (parts.length > 2) {
      setRedeemValue(`${parts[0]}.${parts.slice(1).join("")}`);
      return;
    }

    if (parts[1]?.length > 2) {
      setRedeemValue(`${parts[0]}.${parts[1].slice(0, 2)}`);
      return;
    }

    setRedeemValue(sanitized);
  };

  return (
    <div className="cashback-input" style={{ backgroundColor }}>
      {hasCashback ? (
        <div className="cashback-info">
          <div className="cashback-info_discount">
            <span>
              <b>Cashback:</b> {floatToPriceWithoutSpace(appliedAmount)}
            </span>
            <MdWallet size={24} color="#6E7586" />
          </div>
          <CiCircleRemove
            size={24}
            color="#d7044e"
            style={{ cursor: loading ? "default" : "pointer" }}
            onClick={() => {
              if (!loading) onRemove();
            }}
          />
        </div>
      ) : (
        <div className="cashback-input_form">
          <div className="cashback-input_balance">
            <MdWallet size={18} color="#6E7586" />
            <span>
              Saldo disponível:{" "}
              <b>{floatToPriceWithoutSpace(availableBalance)}</b>
            </span>
          </div>
          <div className="cashback-input_row">
            <Input
              inputAttr={{
                type: "default",
              }}
              name="cashbackRedeem"
              placeholder={
                disabled ? "Não disponível" : "Valor de cashback a resgatar"
              }
              value={redeemValue}
              change={(value: string) => handleChange(value)}
              disabled={loading || disabled}
            />
            <button
              type="button"
              disabled={loading || !redeemValue || disabled}
              onClick={() => onApply()}
            >
              <FiArrowRight size={20} color="#6E7586" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export { CashbackInput };
